/* eslint-disable indent */

import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';

import { DESKTOP, TABLET, MOBILE } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Quotes = () => {

  return (
    <ChangeableBackgroundSection
      id="quotes-background"
      defaultStyle={{ backgroundColor: "#4b4b4b" }}
    >
      <Wrapper>
        <QuotesContainer>
          <Block>
            <ImageLeft>{useImg('arrow_large_right.svg', 'arrow_right')}</ImageLeft>
            <Text>{useText('text_content', true)}</Text>
            <ImageRight>{useImg('arrow_large_right.svg', 'arrow_right')}</ImageRight>
          </Block>
        </QuotesContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.div`
  padding: 15px 0;

  @media ${DESKTOP} {
    display: flex;
    align-items: center;
    min-height: 102px;
  }

  @media ${TABLET} {
    padding: 44px 0;
    min-height: 108px;
  }

  @media ${MOBILE} {
    padding: 28px 0;
  }
`;

const QuotesContainer = styled(Container)`
  @media ${MOBILE} {
    max-width: fit-content;
  }
`;

const Block = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media ${DESKTOP} {
    max-width: 785px;
  }

  @media ${TABLET} {
    justify-content: space-between;
    align-items: flex-start;
  }

  @media ${MOBILE} {
    margin: 0 auto;
  }
`;

const Text = styled.div`
  color: #fff;
  font-weight: 500;
  flex-grow: 1;

  @media ${DESKTOP} {
    font-size: 25px;
    line-height: 1.2;
    text-align: right;
  }

  @media ${TABLET} {
    font-size: 24px;
    line-height: 1.3;
    text-align: center;
    flex-grow: 0;
    padding: 10px;
  }

  @media ${MOBILE} {
    font-size: 24px;
    line-height: 1.3;
    text-align: center;
  }

  br {
    display: none;
  }
`;

const ImageRight = styled.div`
  @media ${DESKTOP} {
    padding-left: 40px;
    width: 120px;
  }

  @media ${TABLET} {
    transform: rotateZ(90deg);
    flex: 0 0 60px;
  }

  @media ${MOBILE} {
    display: none;
  }

  img {
    display: block;
    max-width: 100%;
  }
`;

const ImageLeft = styled.div`
  @media ${DESKTOP} {
    display: none;
  }

  @media ${TABLET} {
    transform: rotateZ(90deg);
    flex: 0 0 60px;
  }

  @media ${MOBILE} {
    display: none;
  }

  img {
    display: block;
    max-width: 100%;
  }
`;

export default Quotes;
